import { type LocationState } from "@/components/framework/locationswitcher/locationReducer";

export type LocationSearchKeys = Pick<LocationState, "selected" | "isShowingLocationTools">;

/**
 * Which search fields LocationSearch clears when the location state changes:
 * closing the location tools clears the input, a new selection clears both.
 */
export function getLocationSearchReset(prev: LocationSearchKeys, next: LocationSearchKeys): { input: boolean; debounced: boolean } {
    const selectionChanged = prev.selected !== next.selected;
    const toolsClosed = prev.isShowingLocationTools && !next.isShowingLocationTools;
    return { input: selectionChanged || toolsClosed, debounced: selectionChanged };
}
